/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Aglohngehaltszahlungen2Inputs */



/**

* @param {_Field_Aglohngehaltszahlungen2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_aglohngehaltszahlungen2 = /** @type {((inputs?: _Field_Aglohngehaltszahlungen2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Aglohngehaltszahlungen2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("AG-Lohn- und Gehaltszahlungen")
});
export { _field_aglohngehaltszahlungen2 as "_field_agLohnGehaltszahlungen" }